import { computed } from 'vue'
import { isEnabled as isFeatureEnabled } from '@/utils/featureToggle'

export default function useFeatureToggle(key = '') {
  const isEnabled = computed(() => isFeatureEnabled(key))
  return { isEnabled }
}
